$(document).ready(function () {
  function variantSwatch () {
    const variantId = Number($(this).attr('data-variant-id'))
    const variantName = $(this).attr('data-variant-name')
    const variantPrice = $(this).attr('data-variant-price')
    const comparePrice = $(this).attr('data-variant-compare-price')
    const variantSelector = $('.main-product__variant-selector')
    const variantOption = variantSelector.find('option')
    const variantAvailable = $(this).attr('data-variant-available')
    const variantPriceWithSellingPlan = $(this).attr('data-price-selling-plan')
    if (variantPriceWithSellingPlan) {
      $('.custom-recharge-widget__purchase-option-text-price').text(variantPriceWithSellingPlan)
    }


    if (variantAvailable === 'false'){
      $('.main-product__add-and-quantity').html("<button class=\"main-product__sold-out-btn\" type=\"button\">\n" +
        "                      Sold out\n" +
        "                    </button>")
    }

    $('.main-product__price--main').text(`${variantPrice}`)
    $('.main-product__price--compare-price').text(`${comparePrice}`)
    $('.main-product__variant-name').text(`${variantName}`)

    variantOption.each(function () {
      if (Number($(this).val()) === variantId) {
        $(this).attr('selected', 'selected')
        variantSelector.attr('value',`${variantId}`)
      } else {
        $(this).removeAttr('selected')
      }
    })
  }

  function mainProductQuantityProcess () {
    const quantityInput = $('.main-product__input-quantity')
    const quantity = Number(quantityInput.val())
    const maxQuantity = Number(quantityInput.attr('max'))
    if ($(this).hasClass('main-product__quantity-btn--plus')) {
      if(quantity === 1) {
        $('.main-product__quantity-btn--minus').removeClass('disabled')
      }
      const newQuantity = quantity + 1
      if (newQuantity === maxQuantity) {
        $(this).addClass('disabled')
      }
      quantityInput.attr('value', newQuantity)
      $('.main-product__quantity-value').text(`${newQuantity}`)
    }else if ($(this).hasClass('main-product__quantity-btn--minus')) {
      const newQuantity = quantity - 1
      if (newQuantity === 1) {
        $(this).addClass('disabled')
      }
      quantityInput.attr('value', newQuantity)
      $('.main-product__quantity-value').text(`${newQuantity}`)
    }
  }

  $('.main-product__variant-swatch-label').on('click', variantSwatch)
  $('.main-product__quantity-btn').on('click', mainProductQuantityProcess)
})